module.exports = __webpack_public_path__ + "img/square.885d5849.svg";